import {
  faInfoCircle,
  faTriangleExclamation,
  faUser,
  faUserTie,
  faSquare,
  faCheckSquare,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React from 'react';
import { Button, Input, Label, UncontrolledTooltip } from 'reactstrap';
import style from './FlexEventItem.style';
import './FlexEventItem.style.css';

const FlexEventItem = ({
  index,
  flexEvent,
  showCheckBox,
  isSelected,
  minutesAdjustment,
  onCheckBoxChange,
  setFlexEventToEdit,
  scheduleData,
  VirtualMeetingMode,
}) => {
  const { FlexTimeEnd, FlexDateEnd, FlexTimeStart, FlexDateStart } = flexEvent;
  const flexEventStart = dayjs(`${FlexDateStart} ${FlexTimeStart}`);
  const flexEventEnd = dayjs(`${FlexDateEnd} ${FlexTimeEnd}`);

  // Calculate modified times if item is selected
  const adjustmentMinutes = parseInt(minutesAdjustment) || 0;
  const modifiedFlexEventStart = isSelected ? flexEventStart.add(adjustmentMinutes, 'minutes') : flexEventStart;
  const modifiedFlexEventEnd = isSelected ? flexEventEnd.add(adjustmentMinutes, 'minutes') : flexEventEnd;

  const { metaData = {} } = scheduleData || {};
  const { MainRoomURL = '' } = metaData || {};
  const { UrlType, CustomUrl, FlexEventName } = flexEvent;

  const isMainRoomAndNoLink = FlexEventName && UrlType === 'AllDay' && !MainRoomURL;
  const isCustomAndNoLink = FlexEventName && UrlType === 'Custom' && !CustomUrl;
  const urlIssue = VirtualMeetingMode !== 'Disabled' && (isMainRoomAndNoLink || isCustomAndNoLink);

  return (
    <div
      // className="flexEventItem"
      style={{
        ...style.simpleRow,
        backgroundColor: isSelected ? '#cfe2ff' : index % 2 == 0 ? 'var(--rr-surface-stripe)' : 'var(--rr-surface)',
        borderBottom: '1px solid gray',
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 10,
        paddingRight: 10,
        cursor: 'pointer',
      }}
      onClick={() => {
        if (setFlexEventToEdit) setFlexEventToEdit(flexEvent);
      }}
    >
      {showCheckBox ? (
        <div style={{ ...style.simpleColumn, width: 25, marginRight: 20 }}>
          <FontAwesomeIcon
            icon={isSelected ? faCheckSquare : faSquare}
            style={{ cursor: 'pointer', fontSize: 25 }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering the parent div's onClick
              const newCheckedState = !isSelected;

              // Create a synthetic event object to match the checkbox behavior
              if (onCheckBoxChange) {
                onCheckBoxChange({ target: { checked: newCheckedState } });
              }
            }}
          />
        </div>
      ) : null}

      <div style={{ ...style.simpleColumn, width: '30%', marginRight: 20 }}>
        {isSelected && adjustmentMinutes !== 0 ? (
          <>
            <div style={{ color: 'red', textDecoration: 'line-through' }}>
              {flexEventStart.format('hh:mm A')} - {flexEventEnd.format('hh:mm A')}
            </div>
            <div style={{ color: 'green', fontWeight: 'bold' }}>
              {modifiedFlexEventStart.format('hh:mm A')} - {modifiedFlexEventEnd.format('hh:mm A')}
            </div>
          </>
        ) : (
          <div style={{ color: '#393939' }}>
            {flexEventStart.format('hh:mm A')} - {flexEventEnd.format('hh:mm A')}
          </div>
        )}
      </div>
      <div style={{ ...style.simpleColumn, width: '20%', marginRight: 20, color: '#393939' }}>
        {`${flexEventEnd.diff(flexEventStart, 'minutes')} minutes`}
      </div>
      <div style={{ ...style.simpleColumn, width: '40%' }}>
        <div style={style.simpleRow}>
          {' '}
          {flexEvent.FlexEventName || flexEvent.EventName}{' '}
          {urlIssue ? (
            <>
              <FontAwesomeIcon
                icon={faTriangleExclamation}
                style={{ cursor: 'pointer', color: 'red', marginTop: 3, marginLeft: 10 }}
                id={`flexEvent_${flexEvent.pk_FlexEvent}_infoIcon`}
              />
              <UncontrolledTooltip target={`flexEvent_${flexEvent.pk_FlexEvent}_infoIcon`}>
                Warning: {isCustomAndNoLink ? `Custom Event URL is missing!` : `Main Room URL is missing!`}
              </UncontrolledTooltip>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FlexEventItem;
